import { z } from "zod";
export const getSuggestPriceSchema = (t, opts) => {
    if (!opts.isSuggestPriceForm)
        return z.object({});
    return z.object({
        suggestPrice: z
            .string({
            invalid_type_error: t("contact.form.suggest_price.error_empty"),
            required_error: t("contact.form.suggest_price.error_empty"),
        })
            .min(1, { message: t("contact.form.suggest_price.error_empty") })
            .max(160, { message: t("contact.form.suggest_price.error_empty") }),
    });
};
